(function ($) {

    $(document).ready(function () {

        //HOME flex one

        var numeroSlide = $('.flex-slider .slide').length;

        if ( numeroSlide > 1 ) {
            $('.flex-one').flickity({
                autoPlay: true,
                draggable: true,
                cellSelector: '.slide',
                prevNextButtons: false,
                cellAlign: 'center',
                wrapAround: true,
                contain: true,
                pageDots: true,
                adaptiveHeight: true,
            });
        }


        //SINGLE product

        var singleCarousel = $('.single-product-wrapper .carousel').flickity({
            autoPlay: true,
            autoPlay: 2500,
            draggable: true,
            cellSelector: '.slide',
            prevNextButtons: true,
            cellAlign: 'center',
            wrapAround: false,
            contain: true,
            pageDots: true,
            adaptiveHeight: false,
        });

    });

})
(jQuery);